import React from 'react';
import QCategoria from '../../libQuestionario/pages/QCategoria';
import PDTAHeader from './components/PDTAHeader';
import { API_SERVICES } from '..';

const PDTACategoria = () => {

  return <QCategoria
    homeRoute={API_SERVICES.PDTA.HOME_ROUTE}
    root={API_SERVICES.PDTA.ROOT}
    title={API_SERVICES.PDTA.NOME}
    headerComponent={<PDTAHeader label="Seleziona un modello o una categoria" />}
  />
}

export default PDTACategoria